export default __webpack_public_path__ + "static/media/oscer-pres-polydipsia.5644fba0.svg";